import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

/**
 * Inline component to show dates/times in a human-readable adaptive manner:
 * <ul>
 * <li>Shows time if the given date/time is within the past 24 hours</li>
 * <li>Shows date if the given date/time is older than 24 hours</li>
 * </ul>
 */
@Component({
    selector: 'time-label',
    template: `<span *ngIf="time">{{ (formattedTime)? formattedTime : time | timeago }}</span>`
})
export class TimeLabel implements OnInit, OnChanges {

    /**
     * Date object to be displayed.
     */
    @Input('time')
    time: Date;

    formattedTime: string;

    constructor(private datePipe: DatePipe) {}

    ngOnInit(){
        this.applyFormat();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.applyFormat();
    }

    applyFormat() {
        if (!this.time) return;

        if (!(this.time instanceof Date)) {
            this.time = new Date(this.time);
        }

        let now = new Date().getTime();
        let given = this.time.getTime();
        if (now - given < 60 * 60 * 1000) {
            // apply the pipe to show seconds/minutes..
            this.formattedTime = null;
        } else if (now - given < 24 * 60 * 60 * 1000) {
            this.formattedTime = this.datePipe.transform(this.time, 'h:mm aa');
        } else {
            this.formattedTime = this.datePipe.transform(this.time, 'd MMM yyyy');
        }
    }

}